import { render, staticRenderFns } from "./procurementContractAudit.vue?vue&type=template&id=204cd790&scoped=true"
import script from "./procurementContractAudit.vue?vue&type=script&lang=js"
export * from "./procurementContractAudit.vue?vue&type=script&lang=js"
import style0 from "./procurementContractAudit.vue?vue&type=style&index=0&id=204cd790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204cd790",
  null
  
)

export default component.exports